import serverConnection from '../common/server-connection.js';
import errorMixin from '../components/error.mixin.js';


export default function() {
  var mishow = new Vue({
    el: 'main',
    mixins: [errorMixin],
    data: {
      categories: [],
      related_programs: ["","",""],
      program: {
        id: "",
        logo: "",
        long_description: "",
        mi_category_ids: "",
        name: "",
        option_types: "",
        points: "",
        price_text: "",
        properties: "",
        rule: "",
        variants: "",
        variants_by_date: ""
      },
      siteLang: site_lang,
      point_types: [],
    },
    computed: {
      pointTypesObject: function(){
        var object = {};
        var that = this;

        $(that.point_types).each(function(){
          object[this.id] = this;
        });

        return object;
      },
    },
    created: function () {
      var that = this;
      var data = {};
      var url = site_lang+"/mi/programs/"+id;
      var method = "GET";

      serverConnection(data, url, method, function(res, xhr){
        that.categories = res.mi_categories;
        that.program = res.program;
        that.related_programs = res.related_programs;
        that.point_types = res.point_types;
        $('.image-placeholder, .content-placeholder').hide();
        $('.suggestions-container').removeClass('hide');
        $('.program-image img, .program-content, .program-card-image, .card-content').show();
      });
    },
    methods: {
        category_img: function(index) {
            let category = this.categories.find(o => o.id == index);
            return category.logo;
        }
    }
  });
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/mishow.js